import React, { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { TextInput } from '@doxyme/ui';
import { Discount } from '../../../../../common/money/discounts';
import { API } from '../../../../../vendor/api';
import { selectUser } from '../../../../../store/features/system';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
export function PromoCodeForm({ currencyCode, productId, onCouponApply, onCouponRemove }) {
    const currentUser = useSelector(selectUser);
    const [couponCode, setCouponCode] = useState('');
    const [isPromotionCodeSubmitted, setIsPromotionCodeSubmitted] = useState(false);
    const [invalidCoupon, setInvalidCoupon] = useState(false);
    const [couponDiscount, setCouponDiscount] = useState('');
    const handleCouponChange = useCallback((value) => {
        setCouponCode(value);
    }, []);
    const handleAddPromotionCode = useCallback(async () => {
        if (!currencyCode || !productId) {
            return;
        }
        setInvalidCoupon(false);
        try {
            const { valid, discount } = await API.purchase.validateCoupon({
                code: couponCode,
                currency: currencyCode,
                product: productId,
                customerId: currentUser?.customerId,
            });
            if (valid) {
                setCouponDiscount(discount);
                setIsPromotionCodeSubmitted(true);
                onCouponApply(couponCode, discount);
            }
            else {
                setInvalidCoupon(true);
            }
        }
        catch (err) {
            console.error(err);
            setInvalidCoupon(true);
        }
    }, [
        couponCode,
        currencyCode,
        productId,
        currentUser?.customerId,
        onCouponApply,
    ]);
    const handleRemovePromotionCode = useCallback(() => {
        setIsPromotionCodeSubmitted(false);
        setCouponDiscount('');
        setCouponCode('');
        setInvalidCoupon(false);
        onCouponRemove();
    }, [onCouponRemove]);
    if (isPromotionCodeSubmitted) {
        return (<div className="payment-setup__promotion-code-applied-label-container">
        <span className="icon-trash-empty" onClick={handleRemovePromotionCode}/>
        <span>
          <FormattedMessage id="auth.payment-setup.promotion-code"/>
          : <b>{couponCode}</b> (<b>{new Discount(couponDiscount).toString()}</b>)
        </span>
      </div>);
    }
    return (<React.Fragment>
      <div className="payment-setup__promotion-code-container">
        <div><FormattedMessage id="auth.payment-setup.promotion-code"/></div>

        <div className="payment-setup__promotion-code-input-container">
          <TextInput type="text" className={classNames('payment-setup__promotion-code-input', {
            'error-border': invalidCoupon
        })} value={couponCode} onChange={(e) => handleCouponChange(e.target.value)}/>
          <button className="payment-setup-promotion-code-button" type="button" disabled={!couponCode} onClick={handleAddPromotionCode}>
            <FormattedMessage id="auth.payment-setup.promotion-code-add-btn"/>
          </button>
        </div>
      </div>

      {invalidCoupon && (<div className="ui-form-helper-text ui-form-helper-text--error payment-setup__promotion-code-error">
          <FormattedMessage id="auth.payment-setup.invalid-promotion-code"/>
        </div>)}
    </React.Fragment>);
}
